<template>
    <app-popover wrapper-element="div" ref="popover" container-class="tooltip" show-background id="top-bar-time-tracker-popover" :close-on-scroll="false">
        <template #default>
            <div v-if="showTopBarTimeTracker" class="popover-overlay-exception">
                <div :class="['time-tracker-header flex flex-vertical-middle no-select', {'time-tracker-background': withBackground}]">
                    <div class="menu-icon window-visible-sm">
                        <router-link #default="{navigate}" :to="{name: 'time-tracker-evaluation-default-list'}" custom>
                            <i v-interact="navigate" class="material-icons" aria-hidden="true" role="img">access_time</i>
                        </router-link>
                    </div>

                    <div v-if="futurTimeClock" class="topbar-module topbar-color">
                        <router-link :to="timeTrackerLink">
                            <div class="topbar-module-icon">
                                <i class="material-icons contrast-primary topbar-icon" aria-hidden="true" role="img">play_circle_outline</i>
                            </div>
                        </router-link>
                    </div>

                    <div v-else-if="manualMode" class="time-tracker-group window-hidden-sm">
                        <router-link :to="timeTrackerLink" aria-label="Zeiterfassung öffnen">
                            <div class="topbar-module-icon">
                                <i class="material-icons contrast-primary topbar-icon" aria-hidden="true" role="img">schedule</i>
                            </div>
                        </router-link>
                    </div>

                    <div class="time-tracker-group window-hidden-sm">
                        <router-link :to="timeTrackerLink" aria-label="Zeiterfassung öffnen">
                            <span class="contrast-primary time">{{currentTime}}</span>
                        </router-link>
                    </div>

                    <template v-if="isTimeClockModeEmployee() && (startDate <= today)">
                        <div class="time-tracker-group">
                            <div class="time-tracker-item no-wrap" :class="{'disabled': isOnPatrol || !canLogin }">
                                <template v-if="isLoggedOut || isBreak">
                                    <span v-if="(!homeOffice && 0 !== checkIp) || (homeOffice && 1 === checkIp)" v-interact="() => track('workbegin')"
                                        :aria-label="currentButtonTooltip"
                                        class="icon-interact">
                                        <i v-tooltip :title="currentButtonTooltip" aria-hidden="true" class="material-icons begin" :class="[{'cursor-not-allowed':!layoutData.time_tracker_data?.allow_work_outside_work_time && getShowOutOfWorkTimePrompt()}, activeAnimationClass]" tabindex="0"
                                            @keydown.space.prevent
                                            @keyup.space="track('workbegin')" @keyup.enter="track('workbegin')" role="img">play_circle_outline</i>
                                    </span>
                                    <span v-if="homeOffice" v-interact="() => track('home')" :aria-label="currentButtonTooltipHomeOffice" class="icon-interact home-office">
                                        <i v-tooltip :title="currentButtonTooltipHomeOffice" aria-hidden="true" :class="activeAnimationClass"
                                            class="material-icons md-28 begin" tabindex="0" @keydown.space.prevent
                                            @keyup.space="track('workbegin')" @keyup.enter="track('workbegin')" role="img">home_work</i>
                                    </span>
                                </template>
                                <template v-else>
                                    <span v-interact="() => track('workend')" aria-label="Arbeitsende" class="icon-interact">
                                        <i v-tooltip="workTooltip" aria-hidden="true" class="material-icons end" :class="activeAnimationClass" tabindex="0" title="Arbeitsende"
                                            @keydown.space.prevent
                                            @keyup.space="track('workend')"
                                            @keyup.enter="track('workend')" role="img">stop</i>
                                    </span>
                                </template>
                            </div>

                            <div class="time-tracker-item">
                                <span id="header-work-time" class="contrast-primary" v-tooltip="'Heutige Arbeitszeit'">
                                    {{formatSeconds(workTime)}}
                                </span>
                            </div>
                        </div>

                        <div class="time-tracker-group">
                            <div class="time-tracker-item" :class="{'disabled': isLoggedOut || isBreak || isOnPatrol}">
                                <span v-interact="() => track('breakbegin')" :aria-label="breakTooltip" class="icon-interact " id="header-breakbegin">
                                    <i v-tooltip="breakTooltip" aria-hidden="true"
                                        :class="[{'cursor-not-allowed': isLoggedOut || isBreak, 'material-icons break': true}, activeAnimationClass]" role="img"
                                    >pause_circle_filled</i>
                                </span>
                            </div>

                            <div class="time-tracker-item">
                                <span id="header-break-time" class="contrast-primary" v-tooltip="'Heutige Pausenzeit'">
                                    {{formatSeconds(breakTime)}}
                                </span>
                            </div>
                        </div>

                        <div v-if="isPatrolActive" class="time-tracker-group patrolButton" v-interact="() => track(!isOnPatrol ?'patrolbegin':'patrolend')" v-tooltip="patrolTooltip" :aria-label="patrolTooltip">
                            <div class="time-tracker-item" :class="{'disabled': isLoggedOut || isBreak}">
                                <span class="icon-interact" id="header-patrolbegin">
                                    <i aria-hidden="true"
                                        :class="[{'cursor-not-allowed': isLoggedOut || isBreak, 'material-icons md-12 patrol': true}, activeAnimationClass]" role="img"
                                        >{{isOnPatrol ? 'work_off' : 'work'}}</i>
                                </span>
                            </div>

                            <div class="time-tracker-item">
                                <span id="header-patrol-time" style="color: #4A4A4A;" :class="{'half-opacity': isLoggedOut || isBreak}">
                                    {{!isOnPatrol ? 'Dienstgang beginnen' : 'Dienstgang beenden ' + formatSeconds(lastEntryStamp)}}
                                </span>
                            </div>
                        </div>

                        <div v-if="((hasProject && lastProject) || (hasContact && lastContact)) && !isLoggedOut && !isBreak && !isOnPatrol" class="time-tracker-group">
                            <div id="time-tracker-project-select-wrapper" class="time-tracker-item" :class="{'no-caret': projects.length === 1}">
                                <!--TODO.gelhaar make pretty-->
                                <div v-if="hasContact" v-interact="changeProject">
                                      <span v-tooltip="lastContactName" class="padding-right-5">
                                        {{lastContactName}}
                                    </span>
                                    <span v-tooltip="projects">
                                        {{lastProjectName}}
                                    </span>
                                    <span class="margin-right-5">
                                        {{formatSeconds(lastProjectWorkTime)}}
                                        <i class="material-icons" aria-hidden="true" role="img">change_circle</i>
                                    </span>
                                </div>
                                <form-select v-else v-model="projectId" :options="projectOptions" :disabled="projects.length === 1" :inherit-width="false" content-width>
                                    <template #one="{option}">
                                        <template v-if="changingProject">
                                            <loading-indicator text="" class="inline small vertical-align-middle padding-right-5"/>
                                            <span>Projekt wird gewechselt...</span>
                                        </template>
                                        <template v-else>
                                            {{option.label}} {{formatSeconds(lastProjectWorkTime)}}
                                        </template>
                                    </template>
                                </form-select>
                            </div>
                        </div>

                        <app-popup v-if="checkCanLogin()" :close-animation="!fromDashboard && layoutData.employee_first_day" :animation-target="animationTarget"
                            :title="isBreak ? 'Pausenwarnung' : 'Arbeitswarnung'"
                            :buttons="popupButtons"
                            v-model="infoPopup" size="medium">
                            <template #default>
                                <template v-if="getShowOutOfWorkTimePrompt()">
                                    <div class="status-messages no-margin-top">
                                        <div class="info">
                                            <i aria-hidden="true" class="material-icons md-light" role="img">info</i>
                                            <template v-if="workTimeData">
                                                Ihre hinterlegten Arbeitszeiten sind: {{workTimeData?.start}} Uhr - {{workTimeData?.end}} Uhr. Sie können Zeiten außerhalb dieses Zeitraumes erfassen, diese werden jedoch nicht Ihrer wöchentlichen Arbeitszeit angerechnet.
                                            </template>
                                            <template v-else>
                                                Außerhalb Ihrer regulären Arbeitstage können Sie sich zwar zur Arbeit anmelden, jedoch wird diese Zeit nicht auf Ihre wöchentliche Arbeitszeit angerechnet, da Ihre festgelegten Arbeitstage {{getWorkDaysAndHoursStringByWorkDays(layoutData!.time_tracker_data!.work_days).days}} sind.
                                            </template>
                                        </div>
                                    </div>
                                    <strong>
                                        Möchten Sie sich trotzdem zur Arbeit anmelden?
                                    </strong>
                                </template>

                                <template v-if="!popupOutOfWorkTimePrompt">
                                    <template v-if="isBreak">
                                        Sie befinden sich derzeit in der Pause.
                                        <template v-if="hasProject">
                                            <template v-if="projects.length">
                                                Wählen Sie bitte zuerst ein Projekt aus, bevor Sie sich wieder zur Arbeit anmelden.
                                            </template>
                                            <template v-else>Sie haben kein Projekt hinterlegt. <strong>Um sich anzumelden, müssen Sie zunächst ein Projekt hinzufügen.</strong>
                                            </template>
                                        </template>
                                        <template v-else-if="hasContact">
                                            Wählen Sie bitte zuerst einen Kontakt aus, bevor Sie sich wieder zur Arbeit anmelden.
                                        </template>
                                        <template v-else>Möchten Sie sich zur Arbeit anmelden?</template>
                                        <br>
                                        <p>
                                            <strong>Zeit der aktuellen Pause</strong>: {{formatSeconds(lastEntryStamp)}}
                                            <br>
                                            <strong>Mindestpausenzeit</strong>: {{formatSeconds(allocatedBreakTime)}}
                                            <template v-if="hasProject">
                                                <br>
                                                <strong>Letztes Projekt</strong>: {{lastProjectName ? lastProjectName + ' (' + formatSeconds(lastProjectWorkTime) + ')' : '/'}}
                                            </template>
                                        </p>

                                        <strong v-html="breakNotice" class="text-danger"></strong>
                                    </template>
                                    <template v-else>
                                        Sie sind derzeit nicht zur Arbeit angemeldet.
                                        <template v-if="hasProject">Um sich zur Arbeit anzumelden, wählen Sie bitte ein Projekt aus.</template>
                                        <template v-else-if="hasContact">Um sich zur Arbeit anzumelden, wählen Sie bitte einen Kontakt aus.</template>
                                        <template v-else>Möchten Sie sich zur Arbeit anmelden?</template>
                                    </template>

                                    <form-row v-if="hasProject && projects.length" label="Projekt" label-for="project-select" required class="default-margin-top">
                                        <form-select id="project-select" v-model="popUpProjectId" :options="projectOptions"/>
                                    </form-row>

                                    <form-row v-if="hasContact" label="Kontakt" label-for="project-select" required class="default-margin-top">
                                        <app-search-tiny ref="institutionSearch" v-model="tinySearchInstitution"
                                            :placeholder="contactLabel" :clearable="contactLabel !== 'Intern'" @clear="clearInstitution"
                                            search-url="/application/ajax/get-contact-suggestions" @apply="chooseInstitution"/>
                                    </form-row>
                                </template>
                            </template>
                        </app-popup>

                        <app-popup title="Projekt wechseln" :buttons="popupChangeButtons" v-model="changeProjectPopup" size="medium">
                            <template #default>
                                <form-row v-if="hasProject && projects.length" label="Projekt" label-for="project-select" required class="default-margin-top">
                                    <form-select id="project-select" v-model="popUpProjectId" :options="projectOptions"/>
                                </form-row>

                                <form-row v-if="hasContact" label="Kontakt" label-for="project-select" required class="default-margin-top">
                                    <app-search-tiny ref="institutionSearch" v-model="tinySearchInstitution"
                                        :placeholder="contactLabel" :clearable="contactLabel !== defaultContactLabel" @clear="clearInstitution"
                                        search-url="/application/ajax/get-contact-suggestions" @apply="chooseInstitution"/>
                                </form-row>
                            </template>
                        </app-popup>
                    </template>
                    <template v-else-if="manualMode">
                        <span><router-link :to="timeTrackerLink" class="contrast-primary">Zeiten eintragen</router-link></span>
                    </template>
                </div>

            </div>
        </template>
        <template #container="{close}">
            <div class="info-popover">
                <i class="material-icons color-primary close-icon" role="img" aria-hidden="true" v-interact="close">close</i>
                <h3 class="color-primary margin-top-10 no-padding">Ihre Zeiterfassung</h3>
                <div class="info-popover-content">
                    <i class="material-icons color-primary large-icon" role="img" aria-hidden="true">access_time</i>
                    <p v-if="manualMode">
                        Hier können Sie Ihre <b>Arbeitszeiten</b> eintragen und einsehen.
                    </p>
                    <p v-else>
                        Hier können Sie sich <b>zur Arbeit</b> oder <b>zur Pause</b> anmelden.
                        <br>
                        Die <b>Auswertung</b> Ihrer <b>Arbeitszeiten</b> finden Sie hier beim <b>Klick auf die Uhrzeit</b>.
                    </p>
                </div>
            </div>
        </template>

    </app-popover>
</template>

<script lang="ts">
    import AppPopover from '@/components/AppPopover.vue';
    import AppSearchTiny from '@/components/AppSearchTiny.vue';
    import {setToMonday} from '@/library/date';
    import {timeTrackerAppOnly, useTerminalApp} from '@/library/intranet';
    import {
        checkCanLogin,
        getShowOutOfWorkTimePrompt,
        getWorkDaysAndHoursStringByWorkDays,
        hasTimeClockMode,
        isManualModeEmployee,
        isTimeClockModeEmployee,
    } from '@/library/modules/time-tracker/time-tracker';
    import {Popup} from '@/library/popup';
    import {NoOperation} from '@/library/utils';
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import {type RouteLocationRaw} from 'vue-router';
    import {Action, Getter, Mutation, namespace, State} from 'vuex-facing-decorator';
    import formatSeconds from '../filters/formatSeconds';
    import dateHelper from '../utils/portuna/dateHelper';
    import AppPopup from './AppPopup.vue';
    import FormRow from './form/FormRow.vue';
    import FormSelect from './form/FormSelect.vue';
    import LoadingIndicator from './LoadingIndicator.vue';

    const TimeTrackerStore = namespace('timeTracker');

    @Component({
        name: 'TopBarTimeTracker',
        components: {
            AppSearchTiny,
            FormSelect,
            FormRow,
            AppPopup,
            LoadingIndicator,
            AppPopover,
        },
        emits: ['initialized'],
        methods: {
            checkCanLogin,
            getWorkDaysAndHoursStringByWorkDays,
            getShowOutOfWorkTimePrompt,
            isTimeClockModeEmployee,
            formatSeconds,
        },
    })
    export default class TopBarTimeTracker extends Vue
    {
        readonly $refs: {
            institutionSearch: AppSearchTiny,
            popover: AppPopover,
        };

        @TimeTrackerStore.Action('track') _track: ({}: {
            record: string,
            projectId: number,
            contactId: number,
        }) => Promise<boolean>;

        @TimeTrackerStore.Action('setPopupProjectPrompt') setPopupProjectPrompt: (byProject: boolean) => void;

        @TimeTrackerStore.Getter('workTimeData') workTimeData;

        @TimeTrackerStore.Getter('currentButtonTooltip') currentButtonTooltip: string;

        @TimeTrackerStore.Getter('getStateString') status: string;

        @TimeTrackerStore.Getter('isBreak') isBreak: boolean;

        @TimeTrackerStore.Getter('isLoggedOut') isLoggedOut: boolean;

        @TimeTrackerStore.Getter('isOnPatrol') isOnPatrol: boolean;

        @TimeTrackerStore.State('popupOutOfWorkTimePrompt') popupOutOfWorkTimePrompt: boolean;

        @TimeTrackerStore.State('patrolActive') isPatrolActive: boolean;

        @TimeTrackerStore.State('lastEntryStampIntl') lastEntryStampIntl: Nullable<string>;

        @TimeTrackerStore.State('allocatedBreakTime') allocatedBreakTime: number;

        @TimeTrackerStore.State('breakTime') stateBreakTime: number;

        @TimeTrackerStore.State('workTime') stateWorkTime: number;

        @TimeTrackerStore.State('lastProjectWorkTime') stateLastProjectWorkTime: number;

        @TimeTrackerStore.State('checkIp') checkIp: number;

        @TimeTrackerStore.State('homeOffice') homeOffice: boolean;

        @TimeTrackerStore.State('patrol') patrol: boolean;

        @TimeTrackerStore.State('startDate') startDate: string;

        @TimeTrackerStore.State('breakNotice') breakNotice: string;

        @TimeTrackerStore.State('hasProject') hasProject: boolean;

        @TimeTrackerStore.State('hasContact') hasContact: boolean;

        @TimeTrackerStore.State('lastProject') lastProject: number;

        @TimeTrackerStore.State('lastContact') lastContact: number;

        @TimeTrackerStore.State('lastContactName') lastContactName: string;

        @TimeTrackerStore.State('projects') projects: ITimeTrackerProjectShort[];

        @TimeTrackerStore.State('contacts') contacts: ITimeTrackerContactShort[];

        @TimeTrackerStore.State('popupProjectPrompt') popupByProject: boolean;

        @State('layoutData') layoutData: LayoutData;

        @Mutation('toggleEmployeeFirstDay') toggleEmployeeFirstDay: () => void;

        @Getter('employeeConfiguration') employeeConfiguration: EmployeeConfiguration;

        @Action('changePopup') changePopup: (options: { id: string, values: Record<string, any> }) => void;

        @Action('subscribeToPopup') subscribeToPopup: (options: { id: string, eventName: string, callback: (any) => any, unsubscribeTime: number }) => void;

        @Prop({
            type: Boolean,
            default: false
        }) withBackground: boolean;

        @Prop({
            type: Boolean,
            default: false,
        }) fromDashboard: boolean;

        useTerminalApp: boolean = useTerminalApp();

        appOnly: boolean = timeTrackerAppOnly();

        institutions: InstitutionSelectMultipleEditEntry[] = [];

        tinySearchInstitution: string = '';

        popUpProjectId: number = 0;

        popupContactId: number = 0;

        projectId: number = 0;

        contactId: number = 0;

        projectWatcherDisabled: boolean = false;

        interval: number = 0;

        currentTime: string = '';

        tmpTime: string = '';

        now: number = Date.now();

        today = dateHelper('Y-m-d') as string;

        initialized: boolean = false;

        popupProjectPrompt: boolean = false;

        changingProject: boolean = false;

        changeProjectPopup: boolean = false;

        defaultContactLabel: string = 'Bitte Kontakt wählen';

        activeAnimationClass = '';

        animationTarget = {};

        get breakTooltip()
        {
            if (this.isOnPatrol)
            {
                return 'Sie müssen sich erst vom Dienstgang abmelden, um sich zur Pause melden zu können.';
            }

            if (this.isLoggedOut)
            {
                return 'Sie müssen sich erst zur Arbeit anmelden, um sich zur Pause melden zu können.';
            }

            if (this.isBreak)
            {
                return 'Sie sind bereits zur Pause angemeldet.';
            }

            return 'Zur Pause anmelden.';
        }

        get workTooltip()
        {
            if (this.isOnPatrol)
            {
                return 'Sie müssen sich erst vom Dienstgang abmelden, um sich von der Arbeit abmelden zu können.';
            }

            return 'Arbeitsende';
        }

        get patrolTooltip()
        {
            if (this.isLoggedOut)
            {
                return 'Sie müssen sich erst zur Arbeit anmelden, um sich zum Dienstgang melden zu können.';
            }

            if (this.isBreak)
            {
                return 'Sie müssen sich erst zur Pause abmelden, um sich zum Dienstgang melden zu können.';
            }

            if (this.isOnPatrol)
            {
                return 'Dienstgang beenden.';
            }

            return 'Zum Dienstgang anmelden.';
        }

        get workTime()
        {
            return Math.round(this.stateWorkTime / 1000);
        }

        get lastProjectWorkTime()
        {
            return Math.round(this.stateLastProjectWorkTime / 1000);
        }

        get breakTime()
        {
            return Math.round(this.stateBreakTime / 1000);
        }

        get lastEntryStamp()
        {
            return Math.round((this.now - new Date(<string>this.lastEntryStampIntl).getTime()) / 1000);
        }

        get infoPopup()
        {
            return !this.appOnly && this.$store.state.timeTracker.popup;
        }

        get currentButtonTooltipHomeOffice()
        {
            return this.currentButtonTooltip + ' (Mobile Arbeit)';
        }

        get projectOptions(): SelectOption[]
        {
            return this.projects.map(project =>
            {
                return {
                    label: project.title,
                    value: project.id,
                };
            });
        }

        get lastProjectName(): string
        {
            return this.projects.filter(({id}) => id === this.lastProject)[0]?.title;
        }

        get popupChangeButtons(): PopupButton[]
        {
            let popupLoginButtonProperties = {};

            if ((this.hasProject && !this.popUpProjectId))
            {
                popupLoginButtonProperties = {
                    disabled: true,
                    tooltip: 'Bitte wählen Sie zunächst ein Projekt aus.',
                };
            }

            if ((this.hasContact && !this.popupContactId))
            {
                popupLoginButtonProperties = {
                    disabled: true,
                    tooltip: 'Bitte wählen Sie zunächst einen Kontakt aus.',
                };
            }

            return [
                {
                    title: 'Abbrechen',
                    icon: 'close',
                    cmd(popup: Popup)
                    {
                        popup.close();
                    },
                },
                Object.assign({
                    title: 'Projekt wechseln',
                    icon: 'play_circle_outline',
                    type: 'success' as ButtonType,
                    cmd: (popup: Popup) =>
                    {
                        this.track('changeproject').then(popup.close);
                    },
                }, popupLoginButtonProperties),
            ];
        }

        get popupButtons(): PopupButton[]
        {
            let buttonText             = this.currentButtonTooltip;
            let type: ButtonType       = this.isBreak ? 'primary' : 'success';
            let buttons: PopupButton[] = [];

            buttons.push({
                title: 'Ohne Anmeldung fortfahren',
                icon: 'close',
                cmd(popup: Popup)
                {
                    popup.close();
                },
            });

            let popupLoginButtonProperties = {};

            if (this.hasProject && !this.popUpProjectId)
            {
                popupLoginButtonProperties = {
                    disabled: true,
                    tooltip: 'Bitte wählen Sie zunächst ein Projekt aus.',
                };
            }

            if ((this.hasContact && !this.popupContactId))
            {
                popupLoginButtonProperties = {
                    disabled: true,
                    tooltip: 'Bitte wählen Sie zunächst einen Kontakt aus.',
                };
            }

            if (!this.hasProject || this.projects.length)
            {
                if (!this.homeOffice && 0 !== this.checkIp || this.homeOffice && 1 === this.checkIp)
                {
                    buttons.push(Object.assign({
                        title: buttonText,
                        icon: 'play_circle_outline',
                        type,
                        cmd: (popup: Popup) =>
                        {
                            this.track('workbegin').then(popup.close);
                        },
                    }, popupLoginButtonProperties));
                }

                if (this.homeOffice)
                {
                    buttons.push(Object.assign({
                        title: buttonText + ' (Mobile Arbeit)',
                        type,
                        icon: 'home',
                        cmd: (popup: Popup) =>
                        {
                            this.track('home').then(popup.close);
                        },
                    }, popupLoginButtonProperties));
                }
            }
            else
            {
                buttons.push({
                    title: 'Hinzufügen',
                    tooltip: 'Um sich anzumelden, müssen Sie zunächst ein Projekt hinzufügen.',
                    type: 'add',
                    icon: 'add',
                    to: {
                        name: 'time-tracker-project-add',
                        params: {
                            track: 'track',
                            ref: this.ref,
                        },
                    },
                });
            }

            return buttons;
        }

        get ref()
        {
            // fullPath for reactivity
            return this.$route.fullPath && this.getReferrer();
        }

        // @todo: via popup-function because -> responsive -> portal in popover menu -> renders only if popover is open
        set infoPopup(value)
        {
            this.$store.dispatch('timeTracker/togglePopup', value);
            this.$store.dispatch('timeTracker/updateLocalStorage');
        }

        get timeTrackerLink(): RouteLocationRaw
        {
            if (this.manualMode)
            {
                const date = new Date();
                setToMonday(date);

                return {
                    name: 'time-tracker-evaluation-view',
                    params: {
                        employee: String(this.currentUser.employeeId),
                        week: dateHelper('Y-m-d', date) as string,
                    },
                };
            }

            return {name: 'time-tracker-evaluation-default-list'};
        }

        get manualMode()
        {
            return isManualModeEmployee();
        }

        get futurTimeClock()
        {
            return (hasTimeClockMode() || this.manualMode) && this.startDate > this.today;
        }

        get contactLabel()
        {
            return this.institutions.length ? this.institutions[0].label : this.defaultContactLabel;
        }

        get showTopBarTimeTracker()
        {
            return !!(!this.appOnly && this.initialized && (this.manualMode || this.startDate));
        }

        get canLogin()
        {
            return checkCanLogin();
        }

        @Watch('layoutData.user.hasTimeTracker', {deep: true})
        watchUserHasTimeTracker()
        {
            // fetch after EA has reloaded layoutData
            this.$store.dispatch('timeTracker/refresh');
        }

        @Watch('showTopBarTimeTracker')
        watchShowTopBarTimeTracker(newValue: boolean, oldValue: boolean)
        {
            if (newValue && !oldValue && this.layoutData.employee_first_day)
            {
                this.changePopup({
                    id: 'personalDashboardPopup',
                    values: {
                        closeAnimation: true,
                        animationTarget: this.animationTarget,
                        onClosePopup: () =>
                        {
                            this.activateAnimation();
                        },
                    },
                });
            }
        }

        @Watch('animationTarget')
        watchAnimationTargetChange()
        {
            this.watchShowTopBarTimeTracker(this.showTopBarTimeTracker, false);
        }

        @Watch('projectId')
        watchProjectId(newValue: number, oldValue: number)
        {
            if (!oldValue || this.projectWatcherDisabled || this.projects.length === 1)
            {
                return;
            }

            this.changingProject = true;

            this.track('changeproject', this.projectId, this.contactId).finally(() =>
            {
                this.changingProject = false;
            });
        }

        @Watch('lastProject')
        watchLastProject(newValue: number, oldValue: number)
        {
            if (!oldValue || !this.lastProject || this.lastProject === this.projectId)
            {
                return;
            }

            this.projectWatcherDisabled = true;
            this.projectId              = this.lastProject;

            this.$nextTick(() =>
            {
                this.projectWatcherDisabled = false;
            });
        }

        @Watch('infoPopup')
        @Watch('projects')
        watchPopUp()
        {
            if (this.infoPopup)
            {
                if (this.projects.length === 1)
                {
                    this.popUpProjectId = this.projects[0].id;
                }
            }
            else
            {
                // reset
                this.popUpProjectId = 0;
            }
        }

        @Watch('infoPopup')
        watchInfoPopup()
        {
            if (!this.infoPopup)
            {
                this.activateAnimation();
            }
        }

        created(): void
        {
            // clears itself when after 30 Seconds the timeTrackerAssistantOutro Popup not exists
            this.subscribeToPopup({
                id: 'timeTrackerAssistantOutro',
                eventName: 'close',
                callback: () =>
                {
                    this.activateAnimation();
                },
                unsubscribeTime: this.layoutData.assistant.time_tracker ? 0 : 30,
            });

            this.$store.dispatch('timeTracker/fetch').then(() =>
            {
                let updateTime = () =>
                {
                    let now         = new Date();
                    this.now        = now.getTime();
                    let currentTime = now.getHours() + ':' + now.getMinutes();

                    if (now.getHours() === 13 && now.getMinutes() === 37 && now.getSeconds() === 0)
                    {
                        console.log('Time!');
                    }

                    if (this.tmpTime !== currentTime)
                    {
                        this.tmpTime     = currentTime;
                        this.currentTime = dateHelper('H:i', Date.now()) as string;
                    }

                    // check every 5 seconds for update
                    if (Math.floor(Date.now() / 1000) % 5)
                    {
                        this.$store.dispatch('timeTracker/fetch');
                    }
                };

                updateTime();

                this.interval    = window.setInterval(updateTime, 1000);
                this.initialized = true;

                this.$emit('initialized');

                this.$nextTick(() =>
                {
                    if (this.$refs.popover && this.$refs.popover.$el)
                    {
                        this.animationTarget = this.$refs.popover.$el.getBoundingClientRect();
                    }
                });

                if (this.hasContact)
                {
                    this.contactId = this.lastContact;
                }

                if (this.hasProject)
                {
                    this.popupProjectPrompt = this.popupByProject;
                    this.projectId          = this.lastProject;

                    this.setPopupProjectPrompt(false);
                }
            });
        }

        disableAnimation()
        {
            if (this.layoutData.employee_first_day && !this.fromDashboard)
            {
                this.toggleEmployeeFirstDay();
                this.changePopup({
                    id: 'personalDashboardPopup',
                    values: {
                        closeAnimation: false,
                        animationTarget: {},
                        onClosePopup: NoOperation,
                    },
                });
            }
        }

        activateAnimation()
        {
            if (!this.layoutData.employee_first_day || this.fromDashboard)
            {
                return;
            }

            this.activeAnimationClass = 'activate-animation';
            setTimeout(() =>
            {
                this.activeAnimationClass = '';
            }, 1000);

            !this.isBreak && !this.isLoggedOut && this.disableAnimation();

            this.$refs.popover.open();
        }

        changeProject()
        {
            this.changeProjectPopup = true;
        }

        track(record: string, projectId?: number, contactId?: number)
        {
            return this._track({
                record,
                projectId: projectId || this.popUpProjectId,
                contactId: contactId || this.popupContactId,
            }).then(tracked =>
            {
                if (tracked)
                {
                    this.$refs.popover.close();
                    this.disableAnimation();
                    this.popUpProjectId = 0;
                    this.popupContactId = 0;
                    this.institutions = [];
                }

                return Promise.resolve(tracked);
            });
        }

        clearInstitution()
        {
            this.institutions   = [];
            this.popupContactId = 0;
        }
        chooseInstitution(institution: InstitutionSelectMultipleTinySearchEntry)
        {
            if (institution.value)
            {
                this.institutions = [
                    {
                        id: 0,
                        institution_id: institution.value,
                        label: institution.label,
                        deleted: 0,
                    },
                ];

                this.popupContactId = institution.value;

                this.tinySearchInstitution = '';
                this.$refs.institutionSearch.resultClear();
                this.$refs.institutionSearch.input.$refs.input.blur();
            }
        }

        unmounted(): void
        {
            window.clearInterval(this.interval);
        }
    }
</script>